import { Icon, Separator, Stack, Text } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"
import {
  PiArchive,
  PiCalendarDots,
  PiEnvelope,
  PiInfo,
  PiNewspaper,
  PiPhone,
  PiUsersThree,
} from "react-icons/pi"

const quickAccessLinks = [
  {
    title: "Schnellzugriff",
    links: [
      { icon: PiEnvelope, label: "Newsletter", link: "/newsletter" },
      { icon: PiArchive, label: "Archiv", link: "/suche" },
      { icon: PiPhone, label: "Kontakt", link: "/kontakt" },
      { icon: PiUsersThree, label: "Über uns", link: "/ueber-uns" },
      { icon: PiInfo, label: "Impressum", link: "/impressum" },
      { icon: PiCalendarDots, label: "Inserate", link: "/inserate" },
      { icon: PiNewspaper, label: "Abo", link: "/abo" },
    ],
  },
]

export const Sidebar = () => {
  return (
    <Stack direction="row" height="fit-content" position="fixed" data-testid="quick-access">
      <Separator
        orientation="vertical"
        height="auto"
        borderColor="main"
        borderLeftWidth="4px"
        opacity="unset"
        ml="4"
      />
      <Stack
        flex="1"
        p={{ base: "4", md: "6" }}
        justifyContent="space-between"
        maxW="fit-content"
      >
        <Stack gap="6">
          {quickAccessLinks.map((quickAccess, i) => (
            <Stack direction="column" key={i} gap="2">
              <Text fontSize={18} fontWeight="bold" color="main">
                {quickAccess.title}
              </Text>
              <Stack gap="1">
                {quickAccess.links.map((item, y) => (
                  <Link key={y} to={item.link}>
                    <Text
                      width="full"
                      justifyContent="start"
                      mt={2}
                      color="main"
                      display="flex"
                      alignItems="center"
                    >
                      <Icon as={item.icon} mr={3} />
                      {item.label}
                    </Text>
                  </Link>
                ))}
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Stack>
  )
}

export default Sidebar
